import React from 'react'
import { ListItem, ListItemIcon } from '@material-ui/core'
import ListItemText from '@material-ui/core/ListItemText'
import YumFormSwitch from '../YumFormSwitch/YumFormSwitch'
import { UseFormReturn } from 'react-hook-form/dist/types'

const YumFormListToggle: React.FC<{
  icon: React.ReactNode
  label: string
  description?: string
  name: string
  form: UseFormReturn<any>
  mb0?: boolean
}> = ({ icon, label, description, name, form, mb0 }) => {
  const { control, watch, setValue } = form
  const value = watch(name)
  const handleClick = () => setValue(name, !value)
  return (
    <ListItem role={undefined} dense button onClick={handleClick} style={{ marginBottom: mb0 ? 0 : '10px' }}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        primary={label}
        secondaryTypographyProps={{
          style: { fontSize: 12 },
        }}
        secondary={description}
      />
      <ListItemIcon>
        <YumFormSwitch control={control} name={name} />
      </ListItemIcon>
    </ListItem>
  )
}

export default YumFormListToggle
